import { createApp } from 'vue'
import { createHead } from './seo/head'
import App from './App.vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './assets/style.css'

const app = createApp(App)
const head = createHead()

app.use(head)
app.use(router)
app.mount('#app')

